import { amountFormatter } from '../../utils/utils';
import { MimaText, Modal } from '../../components';
import { inventoryStore } from '../../stores';
import { observer } from 'mobx-react';
import React from 'react';

const ViewMoreStock = ({ closeModal, goBack, newEditModal, createNewEditModal }) => {
	const { selectedStock } = inventoryStore;

	return (
		<Modal closeModal={closeModal} goBack={closeModal}>

			<div style={{ width: '38rem' }}>
				<MimaText variant="subtitleBold" align="center" mb={3}>
					Stock Information
				</MimaText>
				<MimaText mb={2} labelTitle="Product Type name">
					{selectedStock?.product?.name || ''}
				</MimaText>
				<MimaText mb={2} labelTitle="Stock Name">
					{selectedStock.title}
				</MimaText>
				<MimaText mb={2} labelTitle="Description">
					{selectedStock.description}
				</MimaText>
				<MimaText mb={2} labelTitle="Stock condition">{selectedStock.productCondition}</MimaText>
				<MimaText mb={2} labelTitle="Total Quantity">{selectedStock.quantity}</MimaText>
				<MimaText mb={2} variant="smallBold">
					Cost and Quantity breakdown
				</MimaText>
				{selectedStock?.quantityTracker.map((unit, i) => (
					<div className='modal__beside__grid'>
						<MimaText labelTitle={`Unit Cost price ${i + 1}`}>
							{amountFormatter(selectedStock.currencyCode).format(unit.costPrice)}
						</MimaText>
						<MimaText labelTitle={`Unit Quantity ${i + 1}`}>
							{unit.quantity}
						</MimaText>

					</div>
				))}
				<MimaText mb={2} labelTitle="Selling Price">
					{amountFormatter(selectedStock.currencyCode).format(selectedStock.sellingPrice)}
				</MimaText>
				<MimaText mb={2} labelTitle="Status">{selectedStock.status}</MimaText>
				<MimaText mb={2} labelTitle="Stocks">
					{selectedStock?.variations?.map(
						variant => `${variant.type}: ${variant.value}\n`
					) || ''}
				</MimaText>




			</div>
		</Modal>
	);
};
export default observer(ViewMoreStock);
